import React from 'react'
import { Typography, Row, Col, Switch } from 'antd'
import { EnvironmentOutlined } from '@ant-design/icons'

const { Title, Text, Paragraph } = Typography

interface LocationFraudSubTabProps {
	restrictMockLocation: boolean
	onToggle: (value: boolean) => void
	saving: boolean
}

const LocationFraudSubTab: React.FC<LocationFraudSubTabProps> = ({
	restrictMockLocation,
	onToggle,
	saving,
}) => {
	return (
		<div>
			<Title level={4} style={{ marginBottom: 16 }}>
				<EnvironmentOutlined style={{ marginRight: 8 }} />
				Location Fraud Settings
			</Title>
			<Paragraph type='secondary' style={{ marginBottom: 24 }}>
				Manage settings related to GPS location spoofing and mock locations.
			</Paragraph>

			<Row align='middle' justify='space-between' style={{ padding: '12px 0' }}>
				<Col flex='1'>
					<Title level={5} style={{ margin: 0 }}>
						Restrict GPS Emulator on Check-in and Check-out
					</Title>
					<Text type='secondary'>
						When enabled, the check-in and check-out buttons are automatically disabled
						if the device is using a GPS emulator or mock location. Disable this setting
						to allow check-in/out regardless of location spoofing.
					</Text>
				</Col>
				<Col>
					<Switch
						checked={restrictMockLocation}
						onChange={onToggle}
						loading={saving}
						checkedChildren='Enabled'
						unCheckedChildren='Disabled'
					/>
				</Col>
			</Row>
		</div>
	)
}

export default LocationFraudSubTab
